var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1110 94L1110 122",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110.5,
    cy: 89.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.99 89.1898C1105.99 85.2835 1109.29 82.1168 1113.36 82.1168C1113.94 82.1168 1114.51 82.1841 1115.06 82.3076C1113.74 81.4804 1112.19 81 1110.52 81C1105.81 81 1102 84.8056 1102 89.5C1102 94.1944 1105.81 98 1110.52 98C1112.81 98 1114.89 97.0929 1116.43 95.6205C1115.49 96.0317 1114.45 96.2628 1113.36 96.2628C1109.29 96.2628 1105.99 93.0961 1105.99 89.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.4 88.6003L1119.37 86.1461L1117.54 87.7189L1115.3 87.0564L1116.11 89.3367L1114.77 91.3813L1117.1 91.2179L1118.5 93.144L1119.13 90.7627L1121.34 89.9085L1119.4 88.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.e984c1136e28a9bdf713094cdb1463cf.svg";
export { ForwardRef as ReactComponent };